import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import styled from 'styled-components';

import { colors } from '@gbs-monorepo-packages/styles';

export const ArrowUp = styled(MdKeyboardArrowUp)``;
export const ArrowDown = styled(MdKeyboardArrowDown)``;

export const Container = styled.div`
  display: inline-flex;
  align-items: center;
  border: 1px solid ${colors.blue400};
  background-color: ${colors.white300};
  border-radius: 5px;
  overflow: hidden;
  margin-top: 2px;
`;

export const Text = styled.div`
  background-color: ${colors.white300};
  color: ${colors.text};
  border: none;
  width: 40px;
  text-align: center;
  font-size: 10px;
  height: 13px;
  font-weight: 500;
`;

export const ArrowsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Arrow = styled.div`
  background-color: ${colors.blue400};
  color: ${colors.white300};
  cursor: pointer;
  user-select: none;
  width: 25px;
  height: 13px;
  text-align: center;

  &:hover {
    background-color: ${colors.blue300};
  }
`;
